import type { DependencyList } from "react";
import { useEffect, useRef } from "react";

export function useScrollToTop<T extends HTMLElement>(
  disabled = true,
  deps: DependencyList = []
) {
  const ref = useRef<T>(null);

  useEffect(() => {
    if (!disabled) {
      ref.current?.scrollIntoView({ behavior: "smooth", block: "start" });
    }
    //TODO: Fix Spread, React Hook useEffect has a spread element in its dependency array. This means react can't statically verify whether you've passed the correct dependencies
  }, [disabled, ...deps]);

  return ref;
}
